import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isSignalsPortalUser } from '../../utils/landingPage';

/**
 * Admin Quality Signals deep links (/signals, /signals/constellations): a
 * non-admin signals:read reader (Ravi, Jess) following a shared admin link is
 * routed to the equivalent portal reader page — the admin variant carries
 * admin-only affordances ("Run report now", admin tabs) that would 403 for
 * them. Admins fall through to the admin page unchanged, as do users without
 * the signals:read grant (existing behavior for them is untouched).
 */
export function AdminSignalsDeepLink({
  portalPath,
  children,
}: {
  portalPath: string;
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  if (user && isSignalsPortalUser(user)) {
    return <Navigate to={portalPath} replace />;
  }
  return <>{children}</>;
}
